import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';
import { StorageService } from '@context/frontend/storage';
import { AlgoliaContent } from '@context/shared/types/search';
import { TuiAvatar } from '@taiga-ui/kit';

const IconMap: { [key in 'folder' | 'file']: string } = {
	file: '@tui.sprout',
	folder: '@tui.folder',
};

@Component({
	imports: [TuiAvatar],
	selector: 'ctx-algolia-content-thumbnail',
	templateUrl: 'algolia-content-thumbnail.component.html',
	styleUrl: 'algolia-content-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlgoliaContentThumbnailComponent implements OnInit {
	readonly content = input.required<AlgoliaContent>();

	readonly storageService = inject(StorageService);

	readonly thumbnailUrl = signal<string | null>(null);

	readonly icon = computed(
		() => IconMap[this.content().type as 'file' | 'folder'],
	);

	async ngOnInit() {
		const res = await this.fetchThumbnail();
		this.thumbnailUrl.set(res);
	}

	fetchThumbnail() {
		const content = this.content();
		if (!content.thumbnail) return Promise.resolve(null);

		const storagePath = this.storageService.getReference(content.thumbnail);
		return this.storageService.getDownloadUrl(storagePath);
	}
}
